export default {
  report_id_label: "Report ID",
  report_id_placeholder: "Enter Report ID to search",
  type_label: "Type",
  type_placeholder: "Select type",
  shared_label: "Shared",
  shared_placeholder: "Select shared status",
  report_id: "Report ID",
  date: "Date",
  report_type: "Report Type",
  created_at: "Created At",
  shared: "Shared",
  actions: "Actions",
  view_count: "View Count",
  regenerate: "Regenerate",
  delete_confirm: "Are you sure you want to delete this report?",
  copied: "Link copied to clipboard",
  copied_with_expire: "Link copied to clipboard, will expire on {date}",
  copy_failed: "Failed to copy link",
  share_failed: "Failed to share",
  report_detail: "Report Detail",
  preview_title: "Report Preview",
  data_format_error: "Data format error",
  plan_changed_notice:
    "Your plan has been changed, now using the latest plan ({planType}) to view this report.",
  config_changed_notice:
    "Your config has been changed, now using the latest config to view this report.",
  calculation_deleted_notice: "Some calculations have been deleted.",
  delete_success: "Successfully deleted",
  not_found_title: "Report Not Found",
  not_found_desc: "The report you are looking for does not exist",
  share: "Share",
  copy_link: "Copy Link",
  share_to_x: "Share to X",
  share_to_linkedin: "Share to LinkedIn",
  unshare: "Unshare",
  unshare_success: "Report unshared successfully",
  unshare_failed: "Failed to unshare report",
  shared_expires_at: "Shared expires at",
  privacy_fields_hidden:
    "Privacy fields are hidden by default, can be modified in Settings - Report Configuration, changes take effect immediately",
  want_to_calculate:
    "Want to calculate your own CBAM carbon tax? Get 50 calculations after first calculation",
  register_free: "Register Free",
  use_invitation_code: "Use invitation code",
  failed_to_load_shared_report: "Failed to load shared report",
  report_data_missing: "Report data is missing",
  unable_to_get_shared_report: "Unable to get shared report data",
  carbon_emission_report: "Carbon Emission Report",
  check_out_carbon_emission: "Check out this carbon emission report",
};
